import { BasketDetails } from '@/components/BasketDetails';
import { BasketSummary } from '@/components/BasketSummary';
import { useCheckout } from '@/contexts/checkoutContext';
import { useAuthLinks } from '@/hooks/useAuthLinks';
import { useBreadcrumb } from '@/hooks/useBreadcrumb';
import { useMenuToggle } from '@/hooks/useMenuToggle';
import { useMiniBasket } from '@/hooks/useMiniBasket';
import { useNewsletterSignup } from '@/hooks/useNewsletterSignup';
import { useComponentFactory } from '@/hooks/useComponentFactory';
import { useViewCart } from '@/hooks/useViewCart';
import * as Styled from './BasketApp.styled';

export const BasketApp = () => {
  const {
    checkoutData: { items },
  } = useCheckout();

  const authLinks = useAuthLinks();
  const menuToggle = useMenuToggle();
  const miniBasket = useMiniBasket();
  const breadcrumb = useBreadcrumb();
  const componentFactory = useComponentFactory();
  const newsletterSignup = useNewsletterSignup();

  useViewCart();

  return (
    <>
      {authLinks}
      {menuToggle}
      {miniBasket}
      {breadcrumb}
      <Styled.ContentWrapper>
        <Styled.InnerWrapper>
          <BasketSummary items={items} />
          <BasketDetails />
        </Styled.InnerWrapper>
        
      </Styled.ContentWrapper>
      {componentFactory}
      {newsletterSignup}
    </>
  );
};
